import { Component } from '@angular/core';
import { SearchType } from '../../models/searchType.model';
import { SortType } from 'shared-lib';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrl: './customer.component.scss',
  standalone: false
})
export class CustomerComponent  {
  
  mapSearchBy: Record<number, string> = {
    [SearchType.ACC_NO]: 'Account No.',
    [SearchType.SLRN]: 'SLRN',
    [SearchType.METER_NO]: 'Meter No.',
    [SearchType.BUILDING_OWNER]: 'Building Owner',
    [SearchType.PHONE_NUMBER]: 'Phone No.',
    [SearchType.EMAIL]: 'Email',
  };

  mapSortBy: Record<number, string> = {
      [SortType.NEWEST]: 'Newest',
      [SortType.ID_ASC]: 'ID',
      [SortType.ID_DESC]: 'ID',
      [SortType.SLRN_ASC]: 'SLRN',
      [SortType.SLRN_DESC]: 'SLRN',
    };

  toggleState: boolean = false;
  dropdownState: boolean = false;

  dropdownOpened: boolean = false;
  searchByValue: SearchType = SearchType.BUILDING_OWNER; 
  searchByName: string = this.mapSearchBy[SearchType.BUILDING_OWNER];
  searchByOptions = SearchType;

  sortByValue: SortType = SortType.NEWEST;
  sortByName: string = this.mapSearchBy[SearchType.BUILDING_OWNER];

  handleToggleChange(newValue: boolean) {
    this.toggleState = newValue;
  }

  handleDropdownChange(newValue: boolean){
    this.dropdownState = newValue;
  }

  toggleDropdown(){
    this.dropdownOpened = !this.dropdownOpened;
  }

  selectSearchtByOption(option: SearchType){
    this.searchByValue = option;
    this.searchByName = this.mapSearchBy[option];
    this.dropdownOpened = false;
  }

  onSortChanged(option: SortType){
    this.sortByValue = option;
    this.sortByName = this.mapSortBy[option];
  }
}
